/**
 * This should be a separate file, so SDK logging could be set up without loading all other modules
 */
const noopLogger = {
    verbose: () => { },
    info: () => { },
    warn: () => { },
    error: () => { },
};
let logger = { ...noopLogger };
function setLogger(newLogger) {
    logger = newLogger;
}

const configsByEnvironment = {
    production: {
        contractID: "intents.near",
        poaBridgeBaseURL: "https://bridge.chaindefuser.com",
        solverRelayBaseURL: "https://solver-relay-v2.chaindefuser.com",
        managerConsoleBaseURL: "https://api-mng-console.chaindefuser.com/api/",
    },
    stage: {
        contractID: "staging-intents.near",
        // todo: update URLs when available
        poaBridgeBaseURL: "https://bridge.chaindefuser.com",
        solverRelayBaseURL: "https://solver-relay-v2.chaindefuser.com",
        managerConsoleBaseURL: "https://api-mng-console.chaindefuser.com/api/",
    },
};
let config = {
    env: configsByEnvironment.production,
};
function configureSDK({ logger, env }) {
    if (logger) {
        setLogger(logger);
    }
    if (typeof env === "string") {
        config = { ...config, env: configsByEnvironment[env] };
    }
    else if (env) {
        config = { ...config, env };
    }
}

export { configureSDK as a, config as c, logger as l };
//# sourceMappingURL=config-I7A9m-Yy.js.map
